import { getLocalizedDefaults } from './catalog';
import { normalizeTokenName } from './token-normalization';
import {
  CANONICAL_TOKENS,
  SUPPORTED_LANGUAGES,
  type CanonicalToken,
} from './types';

// Every language's names count in every account, so a template keeps working
// when the account's language changes. Keyed by the folded name.
export const TOKEN_NAME_TO_CANONICAL: ReadonlyMap<string, CanonicalToken> =
  buildTokenNameMap();

function buildTokenNameMap(): Map<string, CanonicalToken> {
  const names = new Map<string, CanonicalToken>();
  const add = (name: string, token: CanonicalToken) => {
    const key = normalizeTokenName(name);
    const existing = names.get(key);
    if (existing && existing !== token) {
      throw new Error(
        `Token name "${name}" maps to both "${existing}" and "${token}"`,
      );
    }
    names.set(key, token);
  };
  for (const token of CANONICAL_TOKENS) add(token, token);
  for (const language of SUPPORTED_LANGUAGES) {
    const { tokenAliases } = getLocalizedDefaults(language);
    for (const token of CANONICAL_TOKENS) {
      const alias = tokenAliases[token];
      if (alias) add(alias, token);
    }
  }
  return names;
}
